import {Box, Grid, InputBase} from "@mui/material";
import {controlSx, FieldLabel, FieldHelper} from "./formFieldShared";

export const CampaignDetailsFieldsNew = ({form, errors, setField}) => {
  return (
    <>
      <Grid item xs={12} md={9}>
        <FieldLabel required>Name</FieldLabel>
        <Box sx={controlSx}>
          <InputBase fullWidth value={form.name} onChange={setField("name")} inputProps={{"aria-label": "Name"}} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
      </Grid>
      <Grid item xs={12} md={3}>
        <FieldLabel required>Max attempts</FieldLabel>
        <Box sx={{...controlSx, ...(errors.maxAttempts && {boxShadow: "inset 0 0 0 1.5px #DC2626"})}}>
          <InputBase fullWidth type="number" inputProps={{min: 1, "aria-label": "Max attempts"}} value={form.maxAttempts} onChange={setField("maxAttempts")} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
        <FieldHelper error={!!errors.maxAttempts}>{errors.maxAttempts || "Maximum calls per number, until it is reached"}</FieldHelper>
      </Grid>
      <Grid item xs={12}>
        <FieldLabel>Description</FieldLabel>
        <Box sx={{...controlSx, height: "auto", alignItems: "flex-start", py: 1}}>
          <InputBase fullWidth multiline minRows={2} inputProps={{maxLength: 2048, "aria-label": "Description"}} value={form.description} onChange={setField("description")} sx={{flex: 1, fontSize: 13, color: "#23264D"}}/>
        </Box>
      </Grid>
    </>
  )
}
